export const FLUX_PROFILE = 'flux://profile';

export const HAS_PROFILE_IMAGE = 'sioc://has_profile_image';

export const HAS_THUMBNAIL_IMAGE = 'sioc://has_profile_thumbnail_image';

export const HAS_GIVEN_NAME = 'sioc://has_given_name';

export const HAS_FAMILY_NAME = 'sioc://has_family_name';

export const HAS_EMAIL = 'sioc://has_email';

export const HAS_USERNAME = 'sioc://has_username';

export const HAS_BIO = 'sioc://has_bio';

export const HAS_BG_IMAGE = 'sioc://has_bg_image';

export const HAS_POST = 'sioc://has_post';

export const AREA_WEBLINK = 'flux://webLink';

export const AREA_COMMUNITY = 'flux://community';

export const AREA_SIMPLE_AREA = 'flux://simpleArea';

export const AREA_HAS_NAME = 'sioc://has_name';

export const AREA_HAS_DESCRIPTION = 'sioc://has_description';

export const AREA_HAS_IMAGE = 'sioc://has_image';

export const AREA_HAS_IMAGES = 'sioc://has_images';

export const AREA_TYPE = 'flux://area_type';

export const HAS_AREA = 'flux://has_aread';

export const OG_LINK = 'og://link';

export const OG_DESCRIPTION = 'og://description';

export const OG_TITLE = 'og://title';

export const OG_IMAGE = 'og://image';

// AD4M Agent

export const AD4M_SOURCE_PROFILE = 'ad4m://profile';

export const AD4M_PREDICATE_USERNAME = 'sioc://has_username';

export const AD4M_PREDICATE_FIRSTNAME = 'sioc://has_firstname';

export const AD4M_PREDICATE_LASTNAME = 'sioc://has_lastname';
